module.exports = __webpack_public_path__ + "static/media/29EUNOG11.4e4a0052.jpg";